import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "../../shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { useTaskTypeFilter } from "./useTaskTypeFilter";
import { useGroupLocationsFilter } from "./useGroupLocationsFilter";
import { usePeriodFilter } from "./usePeriodFilter";
import { useAssigneeOrCreatorFilter } from "./useAssigneeOrCreatorFilter";
import { useUserId } from "@coworker/app/src/core/auth/useLoggedInUser";
import {
  useMyTeam,
  useStoreTeams,
} from "@coworker/app/src/core/hooks/useStoreTeams";
import { useSortByFilter } from "./useSortByFilter";
import { usePriorityOnlyFilter } from "./usePriorityOnlyFilter";
import { useMyOrTeamTasksFilter } from "./useMyOrTeamTasksFilter";
import { FilterValue } from "../../shared/filters/types/filter";
import { useGroupByFilter } from "./useGroupByFilter";
import { useQuantityTypeFilter } from "./useQuantityTypeFilter";

export function useTasksFilters() {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.ACTIVITY_FILTERS
  );

  const userId = useUserId();
  const teams = useStoreTeams();
  const myTeam = useMyTeam();

  const useActivityDataFilters = (values: FilterValue[]) => [
    useMyOrTeamTasksFilter("myTasks", userId, "myString", values),
    useMyOrTeamTasksFilter(
      "teamTasks",
      myTeam?.id ?? "",
      "teamTasksString",
      values
    ),
    useAssigneeOrCreatorFilter(
      "assignedTo",
      userId,
      "assignedToTaskFilterString",
      teams
    ),
    useAssigneeOrCreatorFilter("createdBy", userId, "createdByString", teams),
    usePriorityOnlyFilter(),
    useTaskTypeFilter(),
    useGroupByFilter(values),
    useQuantityTypeFilter(values),
    useGroupLocationsFilter(values),
    usePeriodFilter(),
    useSortByFilter(values),
  ];

  const resetFilters = () => {
    setFilterValues([]);
  };

  return {
    useFiltersFactory: useActivityDataFilters,
    filterValues,
    setFilterValues,
    resetFilters,
  };
}
